(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fiaco-preserved-guide"] && !Shopify.designMode) return;
  try {
    
function initFiacoMaterials(root) {
  if (root.dataset.materialReady) return;
  root.dataset.materialReady = 'true';
  const tabs = [...root.querySelectorAll('[data-material-tab]')];
  const activate = (tab, focus = false) => {
    const id = tab.dataset.materialTab;
    tabs.forEach(item => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-material-panel]').forEach(panel => {
      const active = panel.dataset.materialPanel === id;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    root.querySelectorAll('[data-material-image]').forEach(image => {
      const active = image.dataset.materialImage === id;
      image.classList.toggle('is-active', active);
      image.setAttribute('aria-hidden', String(!active));
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      activate(tabs[next], true);
    });
  });
  root.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-material-panel]');
    const tab = panel && tabs.find(item => item.dataset.materialTab === panel.dataset.materialPanel);
    if (tab) activate(tab);
  });
}
document.querySelectorAll('.fiaco-learn').forEach(initFiacoMaterials);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.fiaco-learn').forEach(initFiacoMaterials));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('fiaco-collection-filter-panel')) {
  customElements.define('fiaco-collection-filter-panel', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-fiaco-filter-toggle]');
      if (!this.button || this.onToggle) return;
      this.onToggle = () => {
        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', String(!expanded));
      };
      this.button.addEventListener('click', this.onToggle);
      this.savedStates = new Map();
      this.media = window.matchMedia('(max-width: 989px)');
      this.syncGroups = () => {
        for (const [details] of this.savedStates) {
          if (!this.contains(details)) this.savedStates.delete(details);
        }
        this.querySelectorAll('#FacetsWrapperDesktop > details').forEach((details) => {
          if (this.media.matches && !this.savedStates.has(details)) {
            this.savedStates.set(details, details.open);
            details.open = true;
          } else if (!this.media.matches && this.savedStates.has(details)) {
            details.open = this.savedStates.get(details);
            this.savedStates.delete(details);
          }
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', String(details.open));
        });
      };
      this.media.addEventListener('change', this.syncGroups);
      this.observer = new MutationObserver(this.syncGroups);
      this.observer.observe(this, { childList: true, subtree: true });
      this.syncGroups();
    }

    disconnectedCallback() {
      if (this.button && this.onToggle) this.button.removeEventListener('click', this.onToggle);
      if (this.media && this.syncGroups) this.media.removeEventListener('change', this.syncGroups);
      if (this.observer) this.observer.disconnect();
      if (this.savedStates) {
        for (const [details, open] of this.savedStates) details.open = open;
      }
      this.onToggle = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
